export const MAX_NUM_SAVED_DEALS = 5;
